import React from "react";
import doctor from "../../images/bg-image/undraw_doctor_kw5l.svg";
import "./About.css";
const About = () => {
  return (
    <div className="pt-12 xl:px-24 lg:px-24 sm:px-0 about-container">
      <div className="grid xl:grid-cols-2 lg;grid-cols-2 md:grid-cols-2 sm:grid-cols-1">
        <div className="py-12 px-5">
          <h5 className="text-base lg:text-xl font-bold text-green-400">
            Affordable study programmes with exclusive online modules fast
            tracking learners to a Scool/College/University qualification.
          </h5>
          <h1 className="text-2xl py-5 lg:py-0 lg:text-5xl leading-relaxed font-bold title-design">
            Our service is all over the Bangladesh
          </h1>

          <div className="lg:pt-8 xl:pl-8 lg:pl-8  sm:px-4 details">
            <p className="xl:pl-4 lg:pl-4 sm:px-8 text-gray-500 text-center lg:text-left  ">
              We’ve served this richly diverse region as a community hospital
              for more than 60 years. And as the area has grown, so have we. But
              as Long Island doctors, nurses, and healthcare professionals,
              we’ve never outgrown our devotion to the health of the community
              we all call home. That commitment can be seen in the Knapp Cardiac
              Care Center, a new surgical pavilion, our level III trauma center,
              our women’s imaging, breast health, orthopedics, bariatrics, and
              so much more. So while we’ve updated our brand to represent our
              growth and the patient-first changes we’ve made, there is one
              thing that will never change: Our commitment to make you feel as
              comfortable in our home as you do in your own.
            </p>
          </div>
        </div>
        <div className="sm:pl-0 pt-4 flex justify-center">
          <img className="w-3/4 pt-24" src={doctor} alt="" />
        </div>
      </div>
    </div>
  );
};

export default About;
